import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import logo from '../assets/Logo.png';

function Header({ activeCategory, activeSubcategory }) {

    const [categories, setCategories] = useState([]);
    const [subcategories, setSubcategories] = useState({});
    const [openCategory, setOpenCategory] = useState(null);
    const [loading, setLoading] = useState(true);

    /*
     * FETCH CATEGORIES + SUBCATEGORIES
     */
    useEffect(() => {

        const fetchData = async () => {

            try {

                // -----------------------------
                // GET CATEGORIES
                // -----------------------------

                const categoryResponse = await fetch(
                    `${process.env.REACT_APP_API_URL}/getcategories`
                );

                if (!categoryResponse.ok) {
                    throw new Error(
                        `Category API Error: ${categoryResponse.status}`
                    );
                }

                const categoryResult =
                    await categoryResponse.json();

                const categoryData =
                    categoryResult.data || [];

                setCategories(categoryData);


                // -----------------------------
                // GET SUBCATEGORIES
                // -----------------------------

                const subcategoryResults = {};


                await Promise.all(

                    categoryData.map(async (category) => {

                        try {

                            const response = await fetch(
                                `${process.env.REACT_APP_API_URL}/getsubcategory/category/${category.category_id}`
                            );


                            /*
                             * If category has no subcategory,
                             * backend may return 404.
                             *
                             * That's NOT an error for us.
                             */
                            if (response.status === 404) {

                                subcategoryResults[
                                    category.category_id
                                ] = [];

                                return;
                            }


                            if (!response.ok) {

                                subcategoryResults[
                                    category.category_id
                                ] = [];

                                return;
                            }


                            const result =
                                await response.json();


                            subcategoryResults[
                                category.category_id
                            ] = result.data || [];

                        } catch (error) {

                            console.error(
                                `Subcategory error for category ${category.category_id}:`,
                                error
                            );

                            subcategoryResults[
                                category.category_id
                            ] = [];
                        }

                    })

                );


                setSubcategories(
                    subcategoryResults
                );

                setLoading(false);

            } catch (error) {

                console.error(
                    'Header loading error:',
                    error
                );

                setLoading(false);
            }

        };


        fetchData();

    }, []);


    /*
     * TOGGLE DROPDOWN
     */
    const handleCategoryClick = (categoryId) => {

        const categorySubs =
            subcategories[categoryId] || [];


        /*
         * If category has subcategories,
         * open / close dropdown.
         */
        if (categorySubs.length > 0) {

            setOpenCategory(
                openCategory === categoryId
                    ? null
                    : categoryId
            );

        } else {

            /*
             * Category without subcategory:
             * nothing to open.
             */
            setOpenCategory(null);
        }
    };


    /*
     * CLOSE DROPDOWN
     */
    const closeDropdown = () => {
        setOpenCategory(null);
    };


    return (

        <nav
            style={{
                backgroundColor: '#FCFCF7',
                position: 'relative',
                top: 0,
                width: '100%',
                minHeight: '70px',
                zIndex: 1000,
                boxShadow:
                    '0 4px 6px rgba(0,0,0,0.1)'
            }}
        >

            <div
                className="container-fluid"
                style={{
                    minHeight: '70px',
                    display: 'flex',
                    alignItems: 'center'
                }}
            >

                {/* =========================
                    LOGO
                ========================= */}

                <div
                    style={{
                        width: '100px',
                        minWidth: '100px',
                        flexShrink: 0
                    }}
                >

                    <img
                        src={logo}
                        alt="Logo"
                        style={{
                            width: '50px',
                            display: 'block'
                        }}
                    />

                </div>


                {/* =========================
                    CATEGORY MENU
                ========================= */}

                <div
                    style={{
                        flex: 1,
                        display: 'flex',
                        justifyContent: 'center',
                        minWidth: 0
                    }}
                >

                    <div
                        style={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            gap: '20px',
                            width: '100%',
                            padding: '0 10px'
                        }}
                    >

                        {loading ? (

                            <span
                                style={{
                                    fontSize: '14px',
                                    color: '#777'
                                }}
                            >
                                Loading...
                            </span>

                        ) : (

                            categories.map((category) => {

                                const categorySubcategories =
                                    subcategories[
                                        category.category_id
                                    ] || [];


                                const hasSubcategories =
                                    categorySubcategories.length > 0;


                                const isActiveCategory =
                                    Number(activeCategory) ===
                                    Number(category.category_id);


                                return (

                                    <div
                                        key={category.category_id}
                                        style={{
                                            position: 'relative',
                                            flexShrink: 0
                                        }}
                                    >

                                        {/* =====================
                                            CATEGORY WITH
                                            SUBCATEGORY
                                        ===================== */}

                                        {hasSubcategories ? (

                                            <button
                                                type="button"
                                                onClick={() =>
                                                    handleCategoryClick(
                                                        category.category_id
                                                    )
                                                }
                                                style={{
                                                    border: 'none',
                                                    background:
                                                        'transparent',
                                                    cursor: 'pointer',

                                                    fontWeight:
                                                        isActiveCategory
                                                            ? '600'
                                                            : '400',

                                                    color:
                                                        isActiveCategory
                                                            ? '#EAA636'
                                                            : '#333',

                                                    fontSize: '14px',

                                                    padding:
                                                        '10px 5px',

                                                    whiteSpace:
                                                        'nowrap'
                                                }}
                                            >

                                                {category.category}

                                                <span
                                                    style={{
                                                        marginLeft:
                                                            '6px',
                                                        fontSize:
                                                            '10px'
                                                    }}
                                                >
                                                    {openCategory ===
                                                    category.category_id
                                                        ? '▲'
                                                        : '▼'}
                                                </span>

                                            </button>

                                        ) : (

                                            /* =====================
                                               CATEGORY WITHOUT
                                               SUBCATEGORY
                                            ===================== */

                                            <Link
                                                to={
                                                    `/album/category/${category.category_id}/${encodeURIComponent(
                                                        category.category
                                                    )}`
                                                }

                                                style={{
                                                    textDecoration:
                                                        'none',

                                                    fontWeight:
                                                        isActiveCategory
                                                            ? '600'
                                                            : '400',

                                                    color:
                                                        isActiveCategory
                                                            ? '#EAA636'
                                                            : '#333',

                                                    fontSize:
                                                        '14px',

                                                    padding:
                                                        '10px 5px',

                                                    display:
                                                        'block',

                                                    whiteSpace:
                                                        'nowrap'
                                                }}
                                            >

                                                {category.category}

                                            </Link>

                                        )}


                                        {/* =========================
                                            SUBCATEGORY DROPDOWN
                                        ========================= */}

                                        {hasSubcategories &&
                                            openCategory ===
                                                category.category_id && (

                                                <div
                                                    style={{
                                                        position:
                                                            'absolute',

                                                        top:
                                                            'calc(100% + 5px)',

                                                        left: '50%',

                                                        transform:
                                                            'translateX(-50%)',

                                                        backgroundColor:
                                                            '#FFFFFF',

                                                        minWidth:
                                                            '200px',

                                                        boxShadow:
                                                            '0 5px 20px rgba(0,0,0,0.18)',

                                                        border:
                                                            '1px solid #eee',

                                                        borderRadius:
                                                            '8px',

                                                        padding:
                                                            '6px 0',

                                                        zIndex:
                                                            9999
                                                    }}
                                                >

                                                    {categorySubcategories.map(
                                                        (subcategory) => {

                                                            const isActiveSubcategory =
                                                                Number(
                                                                    activeSubcategory
                                                                ) ===
                                                                Number(
                                                                    subcategory.subcategory_id
                                                                );


                                                            return (

                                                                <Link
                                                                    key={
                                                                        subcategory.subcategory_id
                                                                    }

                                                                    to={
                                                                        `/album/subcategory/${subcategory.subcategory_id}/${encodeURIComponent(
                                                                            subcategory.subcategory
                                                                        )}`
                                                                    }

                                                                    onClick={
                                                                        closeDropdown
                                                                    }

                                                                    style={{
                                                                        display:
                                                                            'block',

                                                                        padding:
                                                                            '11px 18px',

                                                                        textDecoration:
                                                                            'none',

                                                                        color:
                                                                            isActiveSubcategory
                                                                                ? '#EAA636'
                                                                                : '#333',

                                                                        backgroundColor:
                                                                            isActiveSubcategory
                                                                                ? '#FCFCF7'
                                                                                : '#fff',

                                                                        fontSize:
                                                                            '14px',

                                                                        whiteSpace:
                                                                            'nowrap'
                                                                    }}

                                                                    onMouseEnter={(
                                                                        e
                                                                    ) => {

                                                                        if (
                                                                            !isActiveSubcategory
                                                                        ) {

                                                                            e.currentTarget.style.backgroundColor =
                                                                                '#f5f5f5';

                                                                        }

                                                                    }}

                                                                    onMouseLeave={(
                                                                        e
                                                                    ) => {

                                                                        e.currentTarget.style.backgroundColor =
                                                                            isActiveSubcategory
                                                                                ? '#FCFCF7'
                                                                                : '#fff';

                                                                    }}
                                                                >

                                                                    {
                                                                        subcategory.subcategory
                                                                    }

                                                                </Link>

                                                            );

                                                        }
                                                    )}

                                                </div>

                                            )}

                                    </div>

                                );

                            })

                        )}

                    </div>

                </div>


                {/* =========================
                    RIGHT SPACE
                ========================= */}

                <div
                    style={{
                        width: '100px',
                        minWidth: '100px',
                        flexShrink: 0
                    }}
                />

            </div>

        </nav>

    );

}

export default Header;